import { TrackingEvent } from '@y42/user-tracking-legacy';

export class SignedOutTrackingEvent extends TrackingEvent {
  readonly name = 'SignedOut';
}
